import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicVisitsService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public createVisit(person_id: string | number, name: string): Observable<any> {
    const options = {
      nombre: name,
    };
    return this.publicHttp
      .post("/api/persons/" + person_id + "/visitas", options)
      .pipe(tap((_) => console.log("PublicVisitsService.createVisit: Ok.")));
  }
}
